/**
 * Normalize MUI date picker values (native Date, Dayjs, Moment) to JS Date.
 */
function toJsDate(value) {
  if (value == null) return null;
  if (typeof value.toDate === "function") {
    try {
      return value.toDate();
    } catch {
      /* fall through */
    }
  }
  if (value instanceof Date) {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/**
 * Serialize MUI date picker values for report APIs:
 * start = local midnight, end = local 23:59:59.999 → ISO strings.
 */
export function reportDayStartISO(value) {
  const d = toJsDate(value);
  if (!d) return undefined;
  d.setHours(0, 0, 0, 0);
  return d.toISOString();
}

export function reportDayEndISO(value) {
  const d = toJsDate(value);
  if (!d) return undefined;
  d.setHours(23, 59, 59, 999);
  return d.toISOString();
}
